'use client';
import React, { ReactElement } from 'react';
import {
    ENoItemsCardInfoTextVariant,
    ProfileFallback,
} from '@/components/cutomer-profile/no-items/no-items.component';
import styles from './style.module.scss';

interface NoItemsFoundProfileProps {
    image: string;
    title: string;
    button?: ReactElement;
    children?: ReactElement;
}

const NoItemsFoundProfile: React.FC<NoItemsFoundProfileProps> = ({
    image,
    title,
    button,
    children,
}) => {
    return (
        <ProfileFallback.Root>
            <ProfileFallback.Image
                src={image}
                alt={'no-items'}
                className={styles.image}
            />
            <section className={styles.bottomContainer}>
                <section className={styles.innerTextContainer}>
                    <ProfileFallback.Text
                        variant={ENoItemsCardInfoTextVariant.TITLE}
                        text={title}
                    />
                    <>{children}</>
                </section>
                {button}
            </section>
        </ProfileFallback.Root>
    );
};

export default NoItemsFoundProfile;
